module.exports = __webpack_public_path__ + "fonts/Lato-ThinItalic.4ac7208b.ttf";